import { ReactNode } from "react";

import { DialogActions, DialogActionsProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { layout } from "theme/tokens/semantic/layout";

import { OffWhite } from "assets/colors";

interface IBasicDialogActions extends DialogActionsProps {
  children: ReactNode;
}

const DIALOG_ACTIONS_PADDING = `${layout.dialog.actionsPaddingY}px ${layout.dialog.paddingX}px`;

const useStyles = makeStyles({
  root: {
    "&&": {
      padding: DIALOG_ACTIONS_PADDING,
    },
    backgroundColor: OffWhite,
  },
});

const BasicDialogActions = ({ children, ...props }: IBasicDialogActions) => {
  const classes = useStyles();
  return (
    <DialogActions classes={classes} {...props}>
      {children}
    </DialogActions>
  );
};

export default BasicDialogActions;
